import React from 'react';

import {
  DateField,
  usePermissions,
} from 'react-admin';

import {
  Card,
  CardHeader,
  Box,
  Divider,
  CardContent,
  Grid,
  Typography,
} from '@mui/material';

import EditStatus from '../../customFields/EditStatus';
import RiskClassField from '../../customFields/RiskClassField';

import hasAccess from '../../utilities/hasAccess';

import RiskIndicator from './RiskIndicator';
import RiskScoreSeries from './RiskScoreSeries';
import EditReferenceManyField from '../../customFields/EditReferenceManyField';
import actions, { Actions } from '../../constants/actions';

const RiskManagement = () => {
  const { permissions } = usePermissions<Actions[]>();

  return (
    <Card variant="outlined">
      <CardHeader
        sx={{
          color: 'black',
          fontWeight: 'bold',
          flexWrap: 'wrap',
        }}
        slotProps={{ title: { variant: 'inherit' } }}
        title="Risk management"
        action={(
          <Box alignSelf="center" gap={1} display="flex" mt={1}>
            <Typography variant="smallTitle">
              Last update:
            </Typography>
            <DateField
              variant="smallTitle"
              source="scoreLatestCalculationDate"
              showTime
            />
          </Box>
        )}
      />
      <Divider />
      <CardContent>
        <Grid container spacing={6}>
          <Grid
            size={{
              xs: 12,
              md: 6,
              lg: 12,
              xl: 6,
            }}
          >
            <Grid container spacing={6} pt={5} justifyContent="center">
              <Grid display="flex" justifyContent="center" size={12}>
                <RiskIndicator source="riskScore" />
              </Grid>
              { hasAccess(permissions, actions.SCORE_LIST) && (
                <Grid display="flex" justifyContent="center" size={12}>
                  <RiskScoreSeries />
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
              lg: 12,
              xl: 6,
            }}
          >
            <Grid container spacing={6}>
              <Grid size={12}>
                <EditStatus showEdit={hasAccess(permissions, actions.INDIVIDUAL_UPDATE)} source="status" label="Status" />
              </Grid>
            </Grid>
            { hasAccess(permissions, actions.GROUP_LIST) && (
              <Grid
                py={1}
                size={12}
              >
                <EditReferenceManyField
                  showEdit={hasAccess(permissions, actions.INDIVIDUAL_UPDATE)}
                  source="groups"
                  reference="groups"
                  label="Groups"
                />
              </Grid>
            )}
            <Grid
              py={1}
              size={12}
            >
              <Box>
                <Typography variant="smallTitle">
                  Risk classes
                </Typography>
                <RiskClassField chip source="riskScore" />
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default RiskManagement;
